import { render, staticRenderFns } from "./ListadoDescuentosClientesTabla.vue?vue&type=template&id=56647498"
import script from "./ListadoDescuentosClientesTabla.vue?vue&type=script&lang=js"
export * from "./ListadoDescuentosClientesTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports